// AFL club identity map. Keyed by normalised name (lowercase) with a few common
// aliases so we can resolve whatever the API hands back. Each entry carries an
// abbreviation, the canonical full club name (used to resolve a logo file), and
// brand colours used as the crest fallback / card accent.
const TEAM_META = {
    'adelaide': { abbr: 'ADEL', short: 'Crows', full: 'Adelaide Crows', from: '#002b5c', to: '#e21937' },
    'adelaide crows': { abbr: 'ADEL', short: 'Crows', full: 'Adelaide Crows', from: '#002b5c', to: '#e21937' },
    'brisbane': { abbr: 'BRIS', short: 'Lions', full: 'Brisbane Lions', from: '#7a0026', to: '#b8003c' },
    'brisbane lions': { abbr: 'BRIS', short: 'Lions', full: 'Brisbane Lions', from: '#7a0026', to: '#b8003c' },
    'carlton': { abbr: 'CARL', short: 'Blues', full: 'Carlton Blues', from: '#021733', to: '#0b3b8c' },
    'carlton blues': { abbr: 'CARL', short: 'Blues', full: 'Carlton Blues', from: '#021733', to: '#0b3b8c' },
    'collingwood': { abbr: 'COLL', short: 'Magpies', full: 'Collingwood Magpies', from: '#0a0a0a', to: '#3f3f46' },
    'collingwood magpies': { abbr: 'COLL', short: 'Magpies', full: 'Collingwood Magpies', from: '#0a0a0a', to: '#3f3f46' },
    'essendon': { abbr: 'ESS', short: 'Bombers', full: 'Essendon Bombers', from: '#7a0c1a', to: '#cc2031' },
    'essendon bombers': { abbr: 'ESS', short: 'Bombers', full: 'Essendon Bombers', from: '#7a0c1a', to: '#cc2031' },
    'fremantle': { abbr: 'FRE', short: 'Dockers', full: 'Fremantle Dockers', from: '#1f0a47', to: '#3d1a78' },
    'fremantle dockers': { abbr: 'FRE', short: 'Dockers', full: 'Fremantle Dockers', from: '#1f0a47', to: '#3d1a78' },
    'geelong': { abbr: 'GEEL', short: 'Cats', full: 'Geelong Cats', from: '#012a4f', to: '#1f5d96' },
    'geelong cats': { abbr: 'GEEL', short: 'Cats', full: 'Geelong Cats', from: '#012a4f', to: '#1f5d96' },
    'gold coast': { abbr: 'GC', short: 'Suns', full: 'Gold Coast Suns', from: '#b8121b', to: '#f6b500' },
    'gold coast suns': { abbr: 'GC', short: 'Suns', full: 'Gold Coast Suns', from: '#b8121b', to: '#f6b500' },
    'gws': { abbr: 'GWS', short: 'Giants', full: 'GWS Giants', from: '#27313a', to: '#f47920' },
    'gws giants': { abbr: 'GWS', short: 'Giants', full: 'GWS Giants', from: '#27313a', to: '#f47920' },
    'greater western sydney': { abbr: 'GWS', short: 'Giants', full: 'GWS Giants', from: '#27313a', to: '#f47920' },
    'hawthorn': { abbr: 'HAW', short: 'Hawks', full: 'Hawthorn Hawks', from: '#3a2410', to: '#f6a800' },
    'hawthorn hawks': { abbr: 'HAW', short: 'Hawks', full: 'Hawthorn Hawks', from: '#3a2410', to: '#f6a800' },
    'melbourne': { abbr: 'MELB', short: 'Demons', full: 'Melbourne Demons', from: '#0a1733', to: '#b1163a' },
    'melbourne demons': { abbr: 'MELB', short: 'Demons', full: 'Melbourne Demons', from: '#0a1733', to: '#b1163a' },
    'north melbourne': { abbr: 'NM', short: 'Kangaroos', full: 'North Melbourne Kangaroos', from: '#0a2a6b', to: '#2f6fd0' },
    'north melbourne kangaroos': { abbr: 'NM', short: 'Kangaroos', full: 'North Melbourne Kangaroos', from: '#0a2a6b', to: '#2f6fd0' },
    'kangaroos': { abbr: 'NM', short: 'Kangaroos', full: 'North Melbourne Kangaroos', from: '#0a2a6b', to: '#2f6fd0' },
    'port adelaide': { abbr: 'PORT', short: 'Power', full: 'Port Adelaide Power', from: '#03161a', to: '#00a3b4' },
    'port adelaide power': { abbr: 'PORT', short: 'Power', full: 'Port Adelaide Power', from: '#03161a', to: '#00a3b4' },
    'richmond': { abbr: 'RICH', short: 'Tigers', full: 'Richmond Tigers', from: '#161616', to: '#ffd200' },
    'richmond tigers': { abbr: 'RICH', short: 'Tigers', full: 'Richmond Tigers', from: '#161616', to: '#ffd200' },
    'st kilda': { abbr: 'STK', short: 'Saints', full: 'St Kilda Saints', from: '#1a1a1a', to: '#ed1c24' },
    'st kilda saints': { abbr: 'STK', short: 'Saints', full: 'St Kilda Saints', from: '#1a1a1a', to: '#ed1c24' },
    'sydney': { abbr: 'SYD', short: 'Swans', full: 'Sydney Swans', from: '#7a0c12', to: '#e1251b' },
    'sydney swans': { abbr: 'SYD', short: 'Swans', full: 'Sydney Swans', from: '#7a0c12', to: '#e1251b' },
    'west coast': { abbr: 'WCE', short: 'Eagles', full: 'West Coast Eagles', from: '#062e6f', to: '#f2a900' },
    'west coast eagles': { abbr: 'WCE', short: 'Eagles', full: 'West Coast Eagles', from: '#062e6f', to: '#f2a900' },
    'western bulldogs': { abbr: 'WB', short: 'Bulldogs', full: 'Western Bulldogs', from: '#013a81', to: '#c8102e' },
    'bulldogs': { abbr: 'WB', short: 'Bulldogs', full: 'Western Bulldogs', from: '#013a81', to: '#c8102e' },
};

const FALLBACK = { abbr: '', short: '', full: '', from: '#1e293b', to: '#334155' };

// Reverse index so a 3–4 letter abbreviation (e.g. "HAW", "GWS", "GC") resolves
// to its club. Lets callers pass either a full club name or the stat-row abbr.
const ABBR_INDEX = {};
Object.values(TEAM_META).forEach((m) => {
    if (m.abbr) ABBR_INDEX[m.abbr.toUpperCase()] = m;
});

// Champion Data (and other feed) abbreviations differ from our canonical ones
// — e.g. the prop-tool stats API uses ADE / BRL / CAR / COL / GCS / GEE / MEL /
// NTH / PTA / RIC / WBD. Map every known variant to its club so team lookups
// (and guernsey rendering) resolve regardless of which feed the code is given.
const ABBR_ALIASES = {
    ADE: 'adelaide', ADEL: 'adelaide',
    BRL: 'brisbane', BRIS: 'brisbane', BL: 'brisbane',
    CAR: 'carlton', CARL: 'carlton',
    COL: 'collingwood', COLL: 'collingwood',
    ESS: 'essendon',
    FRE: 'fremantle', FREO: 'fremantle',
    GCS: 'gold coast', GC: 'gold coast', GCFC: 'gold coast',
    GEE: 'geelong', GEEL: 'geelong',
    GWS: 'gws', GWSG: 'gws',
    HAW: 'hawthorn',
    MEL: 'melbourne', MELB: 'melbourne',
    NTH: 'north melbourne', NM: 'north melbourne', NMFC: 'north melbourne', KAN: 'north melbourne',
    PTA: 'port adelaide', PORT: 'port adelaide', PA: 'port adelaide',
    RIC: 'richmond', RICH: 'richmond',
    STK: 'st kilda', SK: 'st kilda',
    SYD: 'sydney',
    WBD: 'western bulldogs', WB: 'western bulldogs', WBFC: 'western bulldogs',
    WCE: 'west coast', WC: 'west coast',
};
Object.entries(ABBR_ALIASES).forEach(([abbr, key]) => {
    if (TEAM_META[key]) ABBR_INDEX[abbr.toUpperCase()] = TEAM_META[key];
});

// Auto-discover every logo dropped into assets/team_logos (svg/png/webp/jpg) so
// new clubs light up without any code change. Keyed by the lowercased filename
// (without extension), e.g. "adelaide crows".
const logoByName = {};
try {
    const ctx = require.context('../../assets/team_logos', false, /\.(svg|png|webp|jpe?g)$/);
    ctx.keys().forEach((key) => {
        const base = key
            .replace(/^\.\//, '')
            .replace(/\.[^.]+$/, '')
            .trim()
            .toLowerCase();
        const mod = ctx(key);
        logoByName[base] = mod && mod.default ? mod.default : mod;
    });
} catch (_e) {
    // require.context is unavailable outside webpack (e.g. some test envs) —
    // logos simply fall back to the coloured crest.
}

export function getTeamMeta(teamName) {
    if (!teamName) return { ...FALLBACK };
    const key = teamName.trim().toLowerCase();
    const meta = TEAM_META[key];
    if (meta) return meta;

    // Match a known club abbreviation (e.g. "HAW", "GWS", "GC") before falling back.
    const byAbbr = ABBR_INDEX[teamName.trim().toUpperCase()];
    if (byAbbr) return byAbbr;

    // Derive a sensible abbreviation from the words we were given so unknown
    // / future clubs still render cleanly.
    const words = teamName.trim().split(/\s+/).filter(Boolean);
    const abbr = words.length === 1
        ? words[0].slice(0, 4).toUpperCase()
        : words.map(w => w[0]).join('').slice(0, 4).toUpperCase();
    return { ...FALLBACK, abbr, short: teamName.trim(), full: teamName.trim() };
}

// Resolve a club logo by trying the canonical full name first, then the raw
// API name. Returns null when no matching file has been added yet.
export function getTeamLogo(teamName) {
    if (!teamName) return null;
    const meta = getTeamMeta(teamName);
    const candidates = [meta.full, teamName]
        .filter(Boolean)
        .map((s) => s.trim().toLowerCase());
    for (const c of candidates) {
        if (logoByName[c]) return logoByName[c];
    }
    return null;
}

export default TEAM_META;
